import React from "react";
import language from "../../language/index.js";
import { Modal } from "../Modal/index.js";
import icons from "../../constants/icons.js";
import {
  getFollowUpMessages,
  addFollowUpMessage,
} from "../../utils/queries/bloodUsageFollowUpQuery.js";

class FollowUpModal extends React.Component {
  state = {
    messages: [],
    newMessage: "",
    isLoading: false,
    isSending: false,
  };

  componentDidMount = async () => {
    await this.loadMessages();
  };

  loadMessages = async () => {
    this.setState({ isLoading: true });
    const res = await getFollowUpMessages(this.props.bloodUsageId);
    const messages = res?.data || [];
    this.setState({ messages, isLoading: false });
  };

  handleSendMessage = async () => {
    const { newMessage } = this.state;
    if (!newMessage.trim()) return;

    this.setState({ isSending: true });
    await addFollowUpMessage(this.props.bloodUsageId, newMessage.trim());
    this.setState({ newMessage: "", isSending: false });
    await this.loadMessages();
  };

  render() {
    const { handleClose, show, defaultLanguage } = this.props;
    const { messages, newMessage, isLoading, isSending } = this.state;

    return (
      <Modal
        handleClose={handleClose}
        show={show}
        title="Follow Up Messages"
        size="lg"
      >
        <div className="card-body">
          <div
            style={{
              maxHeight: "400px",
              overflowY: "auto",
              marginBottom: "16px",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              padding: "12px",
            }}
          >
            {isLoading ? (
              <div className="text-center py-3">
                <span className="spinner-border spinner-border-sm" />
                {" Loading..."}
              </div>
            ) : messages.length === 0 ? (
              <div className="text-center text-muted py-3">
                {language[defaultLanguage]?.no_data || "No messages yet"}
              </div>
            ) : (
              messages.map((msg, i) => (
                <div
                  key={msg._id || i}
                  style={{
                    padding: "10px 12px",
                    marginBottom: "8px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px",
                    borderLeft: "4px solid #0d6efd",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "4px",
                    }}
                  >
                    <strong style={{ fontSize: "0.85rem" }}>
                      {msg.sender?.name || msg.sender?.email || "Unknown"}
                    </strong>
                    <span style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                      {msg.createdAt
                        ? new Date(msg.createdAt).toLocaleString()
                        : ""}
                    </span>
                  </div>
                  <div style={{ fontSize: "0.9rem", whiteSpace: "pre-wrap" }}>
                    {msg.message}
                  </div>
                </div>
              ))
            )}
          </div>

          <div className="input-group">
            <textarea
              className="form-control"
              placeholder="Type your message..."
              value={newMessage}
              onChange={(e) => this.setState({ newMessage: e.target.value })}
              rows={2}
              style={{ resize: "none" }}
            />
            <button
              className="btn btn-primary"
              onClick={this.handleSendMessage}
              disabled={isSending || !newMessage.trim()}
              style={{ marginLeft: "8px" }}
            >
              <span className={process.env.REACT_APP_ICONS_TYPE}>{icons.chat}</span>
              {" Send"}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default FollowUpModal;
